import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 9h8","key":"svg-0"}],["path",{"d":"M8 13h6","key":"svg-1"}],["path",{"d":"M11.99 18.606l-3.99 2.394v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5","key":"svg-2"}],["path",{"d":"M19 22v-6","key":"svg-3"}],["path",{"d":"M22 19l-3 -3l-3 3","key":"svg-4"}]]

const IconMessageUp = createReactComponent('outline', 'message-up', 'MessageUp', __iconNode);

export default IconMessageUp;